import React from "react";
import Header from "../Core/Header";
import Footer from "../Core/Footer";

const Privacy_policy = () => {
  return (
    <>
      <Header />
      <div style={{ padding: "30px" }}>
        A. INTRODUCTION:
        <br />
        ROAMJSSLN PVT. LTD India Private Limited (hereinafter “ROAMJSSLN PVT. LTD”) recognizes the
        importance of privacy of its users and also of maintaining
        confidentiality of the information provided by its users as a
        responsible data controller and data processor.
        <br />
        This Privacy Policy provides for the practices for handling and securing
        user's Personal Information (defined hereunder) by ROAMJSSLN PVT. LTD and its
        subsidiaries and affiliates.
        <br />
        This Privacy Policy is applicable to any person (‘User’) who purchases,
        intends to purchase, or inquire about any product(s) or service(s) made
        available by ROAMJSSLN PVT. LTD through any of ROAMJSSLN PVT. LTD’s customer interface channels
        including its website, mobile site, mobile app & offline channels
        including call centers and offices (collectively referred herein as
        "Sales Channels").
        <br />
        For the purpose of this Privacy Policy, wherever the context so requires
        "you" or "your" shall mean User and the term "we", "us", "our" shall
        mean ROAMJSSLN PVT. LTD. For the purpose of this Privacy Policy, Website means the
        website(s), mobile site(s) and mobile app(s).
        <br />
        By using or accessing the Website or other Sales Channels, the User
        hereby agrees with the terms of this Privacy Policy and the contents
        herein. If you disagree with this Privacy Policy please do not use or
        access our Website or other Sales Channels.
        <br />
        This Privacy Policy does not apply to any website(s), mobile sites and
        mobile apps of third parties, even if their websites/products are linked
        to our Website. User should take note that information and privacy
        practices of ROAMJSSLN PVT. LTD’s business partners, advertisers, sponsors or other
        sites to which ROAMJSSLN PVT. LTD provides hyperlink(s), may be materially different
        from this Privacy Policy. Accordingly, it is recommended that you review
        the privacy statements and policies of any such third parties with whom
        they interact.
        <br />
        This Privacy Policy is an integral part of your User Agreement with ROAMJSSLN PVT. LTD
        and all capitalized terms used, but not otherwise defined herein, shall
        have the respective meanings as ascribed to them in the User Agreement.
        <br />
        B. USERS OUTSIDE THE GEOGRAPHICAL LIMITS OF INDIA
        <br />
        <br />
        Please note that the data shared with ROAMJSSLN PVT. LTD shall be primarily processed
        in India and such other jurisdictions where a third party engaged by
        ROAMJSSLN PVT. LTD may process the data on ROAMJSSLN PVT. LTD’s behalf. By agreeing to this policy,
        you are providing ROAMJSSLN PVT. LTD with your explicit consent to process your
        personal information for the purpose(s) defined in this policy. The data
        protection regulations in India or such other jurisdictions mentioned
        above may differ from those of your country of residence.
        <br />
        If you have any concerns in the processing your data and wish to
        withdraw your consent, you may do so by writing to the following email
        id: privacy@ROAMJSSLN PVT. LTD.com. However, if such processing of data is essential
        for us to be able to provide service to you, then we may not be able to
        serve or confirm your bookings after your withdrawal of consent. For
        instance, if you want to book a bus journey, then certain personal
        information of yours like contact details, gender, location details etc.
        may have to be shared by us with our bus operator and they may further
        process this information for making suitable arrangements for your
        journey.
        <br />
        A withdrawal of consent by you for us to process your information may:
        severely inhibit our ability to serve you properly and in such case, we
        may have to refuse the booking altogether, or unreasonably restrict us
        to service your booking (if a booking is already made) which may further
        affect your trip or may compel us to cancel your booking.
        <br />
        C. TYPE OF INFORMATION WE COLLECT AND ITS LEGAL BASIS
        <br />
        <br />
        The information as detailed below is collected for us to be able to
        provide the services chosen by you and also to fulfill our legal
        obligations as well as our obligations towards third parties as per our
        User Agreement.
        <br />
        "Personal Information" of User shall include the information shared by
        the User and collected by us for the following purposes:
        <br />
        1. Registration on the Website: Information which you provide while
        subscribing to or registering on the Website, including but not limited
        to information about your personal identity such as name, gender, age
        etc., your contact details such as your email address, postal addresses,
        telephone (mobile or otherwise) and/or fax numbers. The information may
        also include information such as your banking details (including
        credit/debit card) and any other information relating to your income
        and/or lifestyle; billing information payment history etc. (as shared by
        you).
        <br />
        2. Other information: We many also collect some other information and
        documents including but not limited to:
        <br />
        Transactional history (other than banking details) about your e-commerce
        activities, buying behavior. Your usernames, passwords, email addresses
        and other security-related information used by you in relation to our
        Services. Data either created by you or by a third party and which you
        wish to store on our servers such as image files, documents etc. Data
        available in public domain or received from any third party including
        social media channels, including but not limited to personal or
        non-personal information from your linked social media channels (like
        name, email address, friend list, profile pictures or any other
        information that is permitted to be received as per your account
        settings) as a part of your account information. Information pertaining
        any other traveler(s) for who you make a booking through your registered
        ROAMJSSLN PVT. LTD account. In such case, you must confirm and represent that each of
        the other traveler(s) for whom a booking has been made, has agreed to
        have the information shared by you disclosed to us and further be shared
        by us with the concerned service provider(s).
        <br />
        <br />
        D. HOW WE USE YOUR PERSONAL INFORMATION
        <br />
        <br />
        The Personal Information collected maybe used in the following manner:
        <br />
        1. While making a booking:
        <br />
        While making a booking, we may use Personal Information including,
        payment details which include cardholder name, credit/debit card number
        (in encrypted form) with expiration date, banking details, wallet
        details etc. as shared and allowed to be stored by you. We may also use
        the information of travelers list as available in or linked with your
        account. This information is presented to the User at the time of making
        a booking to enable you to complete your bookings expeditiously.
        <br />
        2. We may also use your Personal Information for several reasons
        including but not limited to: keep you informed of the transaction
        status; Your usernames, passwords, email addresses and other
        security-related information used by you in relation to our Services.
        send booking confirmations either via SMS or Whatsapp or any other
        messaging service; send any updates or changes to your booking(s); allow
        our customer service to contact you, if necessary; customize the content
        of our website, mobile site and mobile app; request for reviews of
        products or services or any other improvements; send verification
        message(s) or email(s); Validate/authenticate your account and to
        prevent any misuse or abuse.
        <br />
        3. SURVEYS:
        <br />
        <br />
        We value opinions and comments from our Users and frequently conduct
        surveys, both online and offline. Participation in these surveys is
        entirely optional. Typically, the information received is aggregated,
        and used to make improvements to Website, other Sales Channels, services
        and to develop appealing content, features and promotions for members
        based on the results of the surveys. Identity of the survey participants
        is anonymous unless otherwise stated in the survey.
        <br />
        USER GENERATED CONTENT (UGC)
        <br />
        ROAMJSSLN PVT. LTD provides an option to its users to post their experiences by way of
        review, ratings and general poll questions. The customers also have an
        option of posting questions w.r.t a service offered by ROAMJSSLN PVT. LTD or post
        answers to questions raised by other users. ROAMJSSLN PVT. LTD may also contact you or
        hire a third party to contact you (via calls, e-mail, SMS, Whatsapp or
        any other messaging service) and gather feedback about your recent
        booking with ROAMJSSLN PVT. LTD. Though the participation in the feedback process is
        purely optional, you may still receive calls, emails, notifications
        (SMS, Whatsapp or any other messaging service) for you to share your
        feedback. The reviews may be recorded, written or in a video format. The
        reviews shared, written or posted may also be visible on other travel or
        travel related platforms.
        <br />
        The UGC that ROAMJSSLN PVT. LTD collect may be of the following kinds: Review and
        Ratings Question and Answers Crowd Source Data Collection (poll
        questions).
        <br />
        4. MARKETING PROMOTIONS, RESEARCH AND PROGRAMS:
        <br />
        Marketing promotions, research and programs help us to identify your
        preferences, develop programs and improve user experience. ROAMJSSLN PVT. LTD
        frequently sponsors promotions to give its Users the opportunity to win
        great travel and travel related prizes. Personal Information collected
        by us for such activities may include contact information and survey
        questions. We use such Personal Information to notify contest winners
        and survey information to develop promotions and product improvements.
        As a registered User, you will also occasionally receive updates from us
        about fare sales in your area, special offers, new ROAMJSSLN PVT. LTD services, other
        noteworthy items (like savings and benefits on bus tickets, hotel
        reservations, pilgrimage packages, car rentals and other travel
        services) and marketing programs.
        <br />
        In addition, you may look forward to receiving periodic marketing
        emails, newsletters and exclusive promotions offering special deals.
        <br />
        From time to time we may add or enhance services available on the
        Website. To the extent these services are provided, and used by you, we
        will use the Personal Information you provide to facilitate the
        service(s) requested. For example, if you email us with a question, we
        will use your email address, name, nature of the question, etc. to
        respond to your question. We may also store such Personal Information to
        assist us in making the Website the better and easier to use for our
        Users.
        <br />
        ROAMJSSLN PVT. LTD may from time to time launch reward programs by way of which users
        may stand to win travel related rewards or other rewards. We may use
        your Personal Information to enroll you in the rewards program and
        status of the same will be visible each time you log in to the Website.
        Depending on the reward program, each time you win a reward, ROAMJSSLN PVT. LTD may
        share your Personal Information with a third party that will be
        responsible for fulfilling the reward to you. You may however choose to
        opt out of such reward programs by writing to us. For various purposes
        such as fraud detection, offering bookings on credit etc., we at times
        may verify information of customers on selective basis, including their
        credit information.
        <br />
        E. HOW LONG DO WE KEEP YOUR PERSONAL INFORMATION?
        <br />
        <br />
        ROAMJSSLN PVT. LTD will retain your Personal Information on its servers for as long as
        is reasonably necessary for the purposes listed in this policy. In some
        circumstances we may retain your Personal Information for longer periods
        of time, for instance where we are required to do so in accordance with
        any legal, regulatory, tax or accounting requirements.
        <br />
        ROAMJSSLN PVT. LTD will retain your Personal Information on its servers for as long as
        is reasonably necessary for the purposes listed in this policy. In some
        circumstances we may retain your Personal Information for longer periods
        of time, for instance where we are required to do so in accordance with
        any legal, regulatory, tax or accounting requirements.
        <br />
        F. COOKIES AND SESSION DATA
        <br />
        <br />
        1. Cookies
        <br />
        ROAMJSSLN PVT. LTD uses cookies to personalize your experience on the Website and the
        advertisements that maybe displayed. ROAMJSSLN PVT. LTD’s use of cookies is similar to
        that of any other reputable online companies.
        <br />
        Cookies are small pieces of information that are stored by your browser
        on your device's hard drive. Cookies allow us to serve you better and
        more efficiently. Cookies also allow ease of access, by logging you in
        without having to type your login name each time (only your password is
        needed); we may also use such cookies to display any advertisement(s) to
        you while you are on the Website or to send you offers (or similar
        emails – provided you have not opted out of receiving such emails)
        focusing on destinations which may be of your interest.
        <br />
        A cookie may also be placed by our advertising servers, or third party
        advertising companies. Such cookies are used for purposes of tracking
        the effectiveness of advertising served by us on any website, and also
        to use aggregated statistics about your visits to the Website in order
        to provide advertisements in the Website or any other website about
        services that may be of potential interest to you. The third party
        advertising companies or advertisement providers may also employ
        technology that is used to measure the effectiveness of the
        advertisements. All such information is anonymous. This anonymous
        information is collected through the use of a pixel tag, which is an
        industry standard technology and is used by all major websites. They may
        use this anonymous information about your visits to the Website in order
        to provide advertisements about goods and services of potential interest
        to you. No Personal Information is collected during this process. The
        information so collected during this process, is anonymous, and does not
        link online actions to a User.
        <br />
        Most web browsers automatically accept cookies. Of course, by changing
        the options on your web browser or using certain software programs, you
        can control how and whether cookies will be accepted by your browser.
        ROAMJSSLN PVT. LTD supports your right to block any unwanted Internet activity,
        especially that of unscrupulous websites. However, blocking ROAMJSSLN PVT. LTD cookies
        may disable certain features on the Website, and may hinder an otherwise
        seamless experience to purchase or use certain services available on the
        Website. Please note that it is possible to block cookie activity from
        certain websites while permitting cookies from websites you trust.
        <br />
        2. Automatic Logging of Session Data:
        <br />
        Each time you access the Website your session data gets logged. Session
        data may consist of various aspects like the IP address, operating
        system and type of browser software being used and the activities
        conducted by the User while on the Website. We collect session data
        because it helps us analyze User’s choices, browsing pattern including
        the frequency of visits and duration for which a User is logged on. It
        also helps us diagnose problems with our servers and lets us better
        administer our systems. The aforesaid information cannot identify any
        User personally. However, it may be possible to determine a User's
        Internet Service Provider (ISP), and the approximate geographic location
        of User's point of connectivity through the above session data
        <br />
        G. WITH WHOM YOUR PERSONAL INFORMATION IS SHARED
        <br />
        1. Service Providers and suppliers:
        <br />
        Your information shall be shared with the end service providers like
        hotels, bus service providers, cab rental or any other suppliers who are
        responsible for fulfilling your booking. You may note that while making
        a booking with ROAMJSSLN PVT. LTD you authorize us to share your information with the
        said service providers and suppliers. It is pertinent to note that ROAMJSSLN PVT. LTD
        does not authorize the end service provider to use your information for
        any other purpose(s) except as may be for fulfilling their part of
        service. However, how the said service providers/suppliers use the
        information shared with them is beyond the purview and control of ROAMJSSLN PVT. LTD
        as they process Personal Information as independent data controllers,
        and hence we cannot be made accountable for the same. You are therefore
        advised to review the privacy policies of the respective service
        provider or supplier whose services you choose to avail.
        <br />
        ROAMJSSLN PVT. LTD does not sell or rent individual customer names or other Personal
        Information of Users to third parties except sharing of such information
        with our business / alliance partners or vendors who are engaged by us
        for providing various referral services and for sharing promotional and
        other benefits to our customers from time to time basis their booking
        history with us.
        <br />
        <br />
        2. COMPANIES IN THE SAME GROUP:
        <br />
        In the interests of improving personalization and service efficiency, we
        may, under controlled and secure circumstances, share your Personal
        Information with our affiliate or associate entities.
        <br />
        If the assets of ROAMJSSLN PVT. LTD are acquired, our customer information may also be
        transferred to the acquirer depending upon the nature of such
        acquisition. In addition, as part of business
        expansion/development/restructuring or for any other reason whatsoever,
        if we decide to sell/transfer/assign our business, any part thereof, any
        of our subsidiaries or any business units, then as part of such
        restructuring exercise customer information including the Personal
        Information collected herein shall be transferred accordingly.
        <br />
        3. BUSINESS PARTNERS AND THIRD-PARTY VENDORS:
        <br />
        We may also share certain filtered Personal Information to our corporate
        affiliates or business partners who may contact the customers to offer
        certain products or services, which may include free or paid products /
        services, which will enable the customer to have better travel
        experience or to avail certain benefits specially made for ROAMJSSLN PVT. LTD
        customers. Examples of such partners are entities offering co-branded
        credit cards, travel insurance, insurance cover against loss of wallet,
        banking cards or similar sensitive information etc. If you choose to
        avail any such services offered by our business partners, the services
        so availed will be governed by the privacy policy of the respective
        service provider.
        <br />
        ROAMJSSLN PVT. LTD may share your Personal Information to third party that ROAMJSSLN PVT. LTD may
        engage to perform certain tasks on its behalf, including but not limited
        to payment processing, data hosting, and data processing platforms.
        <br />
        We use non-identifiable Personal Information of Users in aggregate or
        anonymized form to build higher quality, more useful online services by
        performing statistical analysis of the collective characteristics and
        behavior of our customers and visitors, and by measuring demographics
        and interests regarding specific areas of the Website. We may provide
        anonymous statistical information based on this data to suppliers,
        advertisers, affiliates and other current and potential business
        partners. We may also use such aggregate data to inform these third
        parties as to the number of people who have seen and clicked on links to
        their websites. Any Personal Information which we collect and which we
        may use in an aggregated format is our property. We may use it, in our
        sole discretion and without any compensation to you, for any legitimate
        purpose including without limitation the commercial sale thereof to
        third parties.
        <br />
        Occasionally, ROAMJSSLN PVT. LTD will hire a third party for market research, surveys
        etc. and will provide information to these third parties specifically
        for use in connection with these projects. The information (including
        aggregate cookie and tracking information) we provide to such third
        parties, alliance partners, or vendors are protected by confidentiality
        agreements and such information is to be used solely for completing the
        specific project, and in compliance with the applicable regulations.
        <br />
        4. DISCLOSURE OF INFORMATION
        <br />
        In addition to the circumstances described above, ROAMJSSLN PVT. LTD may disclose
        User's Personal Information if required to do so:
        <br />
        by law, required by any enforcement authority for investigation, by
        court order or in reference to any legal process; to conduct our
        business; for regulatory, internal compliance and audit exercise(s) to
        secure our systems; or to enforce or protect our rights or properties of
        ROAMJSSLN PVT. LTD or any or all of its affiliates, associates, employees, directors
        or officers or when we have reason to believe that disclosing Personal
        Information of User(s) is necessary to identify, contact or bring legal
        action against someone who may be causing interference with our rights
        or properties, whether intentionally or otherwise, or when anyone else
        could be harmed by such activities. Such disclosure and storage may take
        place without your knowledge. In that case, we shall not be liable to
        you or any third party for any damages howsoever arising from such
        disclosure and storage.
        <br />
        H. HOW CAN YOU OPT-OUT OF RECEIVING OUR PROMOTIONAL E-MAILS?
        <br />
        You will occasionally receive e-mail updates from us about fare sales in
        your area, special offers, new ROAMJSSLN PVT. LTD services, and other noteworthy
        items. We hope you will find these updates interesting and informative.
        If you wish not to receive them, please click on the "unsubscribe" link
        or follow the instructions in each e-mail message.
        <br />
        1. PERMISSIONS REQUIRED FOR USING OUR MOBILE APPLICATIONS
        <br />
        When the ROAMJSSLN PVT. LTD app is installed on your phone or tablet, a list of
        permissions appear and are needed for the app to function effectively.
        There is no option to customize the list. The permissions that ROAMJSSLN PVT. LTD
        requires and the data that shall be accessed and its use is as below:
        <br />
        1. Android permissions:
        <br />
        Device and App history:We need your device permission to get information
        about your device, like OS (operating system) name, OS version, mobile
        network, hardware model, unique device identifier, preferred language,
        etc. Basis these inputs, we intend to optimize your travel booking
        experience. Identity:This permission enables us to know about details of
        your account(s) on your mobile device. We use this info to auto-fill
        your email ID’s and provide a typing free experience. It also helps us
        map email ID’s to a particular user to give you the benefit of exclusive
        travel offers, wallet cash-backs, etc. It also allows facilitating your
        Facebook and Google+ login. Location:This permission enables us to give
        you the benefit of location specific deals and provide you a
        personalized experience. When you launch ROAMJSSLN PVT. LTD app to make a travel
        booking, we auto-detect your location so that your nearest city is
        auto-filled. We also require this permission to be able to help you
        track your bus with respect to your location. ROAMJSSLN PVT. LTD collects and uses
        location data to find boarding points near you and provide real-time
        travel updates. SMS:If you allow us to access your SMS, we read your SMS
        to autofill or prepopulate ‘OTP’ while making a transaction and to
        validate your mobile number. This provides you a seamless purchase
        experience while making a booking and you don’t need to move out of the
        app to read the SMS and then enter it in the app. Phone:The app requires
        access to make phone calls so that you can make phone calls to bus
        operators, hotels and our customer contact centers directly through the
        app. Contacts:If you allow us to access your contacts, it enables us to
        provide a lot of social features to you such as sharing tickets or
        location with your friends. This permission also allows you to select
        numbers from your contacts for mobile recharges done on the app. Photo/
        Media/ Files:The libraries in the app use these permissions to allow
        users to to save and upload multimedia reviews. Wi-Fi connection
        information:When you allow us the permission to detect your Wi-Fi
        connection, we optimize your bandwidth usage for multimedia uploads.
        Device ID and Call information:This permission is used to detect your
        Android ID through which we can uniquely identify users. It also lets us
        know your contact details using which we pre-populate specific fields to
        ensure a seamless booking experience. Camera:This permission is used to
        capture pictures of the boarding point or bus before the journey. This
        images can then uploaded as part of multimedia reviews. Calendar:This
        permission enables us to put your travel plans on your calendar.
        <br />
        2. IOS permissions:
        <br />
        Notifications:If you opt in for notifications, it enables us to send
        across exclusive deals, promotional offers, travel related updates, etc.
        on your device. If you do not opt for this, updates for your travel like
        booking confirmation, refund (in case of cancellation), etc. will be
        sent through SMS. Contacts:This permission enables us to know about
        details of your account(s) on your mobile device. We use this info to
        auto-fill your email ID’s and provide a typing free experience. It also
        helps us map email ID’s to a particular user to give you the benefit of
        exclusive travel offers, wallet cash-backs, etc. It also allows
        facilitating your Facebook and Google+ login. Location:This permission
        enables us to give you the benefit of location specific deals and
        provide you a personalized experience. When you launch ROAMJSSLN PVT. LTD app to make
        a travel booking, we auto-detect your location so that your nearest city
        is auto-filled. We also require this permission to be able to help you
        track your bus with respect to your location. ROAMJSSLN PVT. LTD collects and uses
        location data to find boarding points near you and provide real-time
        travel updates Photo/ Media/ Files:The libraries in the app use these
        permissions to allow users to to save and upload multimedia reviews.
        Camera:This permission is used to capture pictures of the boarding point
        or bus before the journey. This images can then uploaded as part of
        multimedia reviews. Calendar:This permission enables us to put your
        travel plans on your calendar.
        <br />
        J. HOW WE PROTECT YOUR PERSONAL INFORMATION?
        <br />
        All payments on the Website are secured. This means all Personal
        Information you provide is transmitted using TLS (Transport Layer
        Security) encryption. TLS is a proven coding system that lets your
        browser automatically encrypt, or scramble, data before you send it to
        us. Website has stringent security measures in place to protect the
        loss, misuse, and alteration of the information under our control.
        Whenever you change or access your account information, we offer the use
        of a secure server. Once your information is in our possession we adhere
        to strict security guidelines, protecting it against unauthorized
        access.
        <br />
        K. WITHDRAWAL OF CONSENT AND PERMISSION You may withdraw your consent to
        submit any or all Personal Information or decline to provide any
        permissions on its Website as covered above at any time. In case, you
        choose to do so then your access to the Website may be limited, or we
        might not be able to provide the services to you. You may withdraw your
        consent by sending an email to privacy@ROAMJSSLN PVT. LTD.com L. YOUR RIGHTS QUA
        PERSONAL INFORMATION You may access your Personal Information from your
        user account with ROAMJSSLN PVT. LTD. You may also correct your personal information
        or delete such information (except some mandatory fields) from your user
        account directly. If you don’t have such a user account, then you write
        to privacy@ROAMJSSLN PVT. LTD.com M. ELIGIBILITY TO TRANSACT WITH ROAMJSSLN PVT. LTD We reserve the
        rights to revise the Privacy Policy from time to time to suit various
        legal, business and customer requirement. We will duly notify the users
        as may be necessary. N. CHANGES TO THE PRIVACY POLICY You must atleast
        18 years of age to transact directly with ROAMJSSLN PVT. LTD and also to consent to
        the processing of your personal data. You may always submit concerns
        regarding this Privacy Policy via email to us at privacy@ROAMJSSLN PVT. LTD.com. ROAMJSSLN PVT. LTD
        shall endeavor to respond to all reasonable concerns and inquiries. O.
        DELETION OF ACCOUNT OR PERSONAL INFORMATION In case you want to delete
        your account or your personal information, you may write to us at
        privacy@ROAMJSSLN PVT. LTD.com, requesting for deletion of your account. Please note
        that the DPO may require you to verify your identity before proceeding
        with your request of deleting your account. Any identity proof that you
        may provide shall be stored for a period of 21 days from the date of
        deletion of the account. If you do delete the account or personal
        information, please note that ROAMJSSLN PVT. LTD may keep your transactional
        information, if required as per applicable local laws. Further, you may
        not be able to use the same credentials (email ID/mobile number) to
        create another account with ROAMJSSLN PVT. LTD for a period of 12 months from the date
        of deletion of the account
      </div>
      <Footer />
    </>
  );
};

export default Privacy_policy;
